import { uniqueId } from 'lodash';
import React, { useState, useEffect } from 'react';
import { ITooltip, Tooltip } from 'react-tooltip';

interface TooltipTwoProps extends ITooltip {
    title: React.ReactNode;
    children: React.ReactNode;
}

const TooltipTwo = ({
    title,
    children,
    content,
    ...props
}: TooltipTwoProps) => {
    const id = uniqueId('tooltip-');
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div>
            <a data-tooltip-id={props.id ?? id}>
                {children}
            </a>
            <Tooltip id={props.id ?? id} openOnClick={isMobile} variant='light' style={{
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
                border: '1px solid #e0e0e0',
                borderRadius: '6px',
                zIndex: 9999,
            }} place='bottom' {...props}>
                {title}
            </Tooltip>
        </div>
    );
};

export default TooltipTwo;
